/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import Trigger from '@cloud-sn/v-trigger';
import placements from './placements';
var __vue_script__ = {
  name: 'Tooltip',
  components: {
    Trigger: Trigger
  },
  props: {
    prefixCls: {
      type: String,
      default: 'v-tooltip'
    },
    visible: {
      type: Boolean,
      default: false
    },
    content: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placement: {
      type: String,
      default: 'left'
    },
    trigger: {
      type: [String, Array],
      default: function _default() {
        return ['hover'];
      },
      validator: function validator(val) {
        var vals = val;

        if (!Array.isArray(val)) {
          vals = [vals];
        }

        if (vals.length === 0) {
          return false;
        }

        return vals.every(function (v) {
          return ['none', 'click', 'hover', 'focus'].indexOf(v) > -1;
        });
      }
    },
    destroyTooltipOnHide: {
      type: Boolean,
      default: false
    },
    builtinPlacements: {
      type: Object,
      default: function _default() {
        return placements;
      }
    },
    align: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    // ms
    mouseEnterDelay: {
      type: Number,
      default: 0
    },
    // ms
    mouseLeaveDelay: {
      type: Number,
      default: 100
    },
    transitionName: {
      type: String,
      default: ''
    },
    animation: {
      type: String,
      default: ''
    },
    tooltipClass: {
      type: [String, Array, Object],
      default: ''
    },
    tooltipStyle: {
      type: Object,
      default: null
    },
    getPopupContainer: {
      type: Function,
      default: null
    }
  },
  data: function data() {
    return {
      open: false
    };
  },
  computed: {
    isOpen: function isOpen() {
      var disabled = this.disabled,
          open = this.open;
      return !disabled && open;
    },
    actions: function () {
      var trigger = this.trigger,
          disabled = this.disabled;

      if (disabled) {
        return [];
      }

      var actions = trigger;

      if (!Array.isArray(trigger)) {
        actions = [trigger];
      }

      return actions;
    }
  },
  watch: {
    visible: function visible(nVal, oVal) {
      if (nVal !== oVal) {
        this.setOpen(nVal);
      }
    }
  },
  created: function created() {
    this.setOpen(this.visible);
  },
  methods: {
    setOpen: function setOpen(visible) {
      this.open = visible;
    },
    onPopupVisible: function onPopupVisible(visible) {
      this.setOpen(visible);
      this.$emit('visible-change', visible);
    },
    updateTooltipAlign: function updateTooltipAlign() {
      var tooltipTriggerRef = this.$refs.tooltipTriggerRef;

      if (tooltipTriggerRef) {
        tooltipTriggerRef.forcePopupAlign();
      }
    }
  }
};
/* template */

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('trigger', {
    ref: "tooltipTriggerRef",
    attrs: {
      "visible": _vm.isOpen,
      "prefix-cls": _vm.prefixCls,
      "destroy-popup-on-hide": _vm.destroyTooltipOnHide,
      "builtin-placements": _vm.builtinPlacements,
      "popup-placement": _vm.placement,
      "popup-align": _vm.align,
      "actions": _vm.actions,
      "mouse-enter-delay": _vm.mouseEnterDelay,
      "mouse-leave-delay": _vm.mouseLeaveDelay,
      "popup-transition-name": _vm.transitionName,
      "popup-animation": _vm.animation,
      "popup-class": _vm.tooltipClass,
      "popup-style": _vm.tooltipStyle,
      "get-popup-container": _vm.getPopupContainer
    },
    on: {
      "on-popup-visible-change": _vm.onPopupVisible
    }
  }, [_c('template', {
    slot: "trigger"
  }, [_vm._t("default")], 2), _vm._v(" "), _c('template', {
    slot: "popup"
  }, [_c('div', {
    class: _vm.prefixCls + "-arrow"
  }), _vm._v(" "), _c('div', {
    class: _vm.prefixCls + "-inner"
  }, [_vm._t("content", [_vm._v("\n        " + _vm._s(_vm.content) + "\n      ")])], 2)])], 2);
};

var __vue_staticRenderFns__ = [];
/* style */

var __vue_inject_styles__ = undefined;
/* scoped */

var __vue_scope_id__ = undefined;
/* module identifier */

var __vue_module_identifier__ = undefined;
/* functional template */

var __vue_is_functional_template__ = false;
/* component normalizer */

function __vue_normalize__(template, style, script, scope, functional) {
  var component = (typeof script === 'function' ? script.options : script) || {}; // For security concerns, we use only base name in production mode.

  component.__file = "tooltip.js";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;
  return component;
}
/* style inject */

/* style inject SSR */


export default __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__, __vue_module_identifier__, undefined, undefined);